export const getLinkWithSearchParams = (link: string, params: string) => {
  const searchParams = new URLSearchParams(params);

  return `${link}?${searchParams.toString()}`;
}

/**
 * Формирует ссылку на форму с учетом того, является ли она внешней или внутренней
 * @param link - базовая ссылка (например, 'formular')
 * @param params - параметры поиска
 * @param isExternal - флаг, указывающий, что это внешняя ссылка
 * @returns сформированная ссылка
 */
export const getFormLinkWithParams = (link: string, params: string, isExternal: boolean = false) => {
  const searchParams = new URLSearchParams(params);
  const linkWithParams = `${link}?${searchParams.toString()}`;

  // Если это внешняя ссылка (iframe), не добавляем "/"
  // Если это внутренняя ссылка, добавляем "/" для корректной работы с SEO-страницами
  return isExternal ? linkWithParams : "/" + linkWithParams;
}
